export default "__VITE_ASSET__e28f1f69__"